import PieChartRepository from '@src/repositories/PieChartRepository';

class PieChartService {
  constructor() {
    this.pieChartRepository = new PieChartRepository();
  }

  async createPieChart({ data, orgId, divId = null, boardId }) {
    return this.pieChartRepository.create({ data, orgId, divId, boardId });
  }

  async updatePieChart({ data, orgId, divId = null, boardId, chartId }) {
    return this.pieChartRepository.update({ data, orgId, divId, boardId, chartId });
  }

  async getPieChart({ orgId, divId = null, boardId, chartId }) {
    return this.pieChartRepository.get({ orgId, divId, boardId, chartId });
  }
}

export default PieChartService;
